/**
 * RNC Fall Ritual / September promo — cart gift automation.
 * Qualifying Subscribe & Save product handles come from #rnc-sept-promo-config.
 * The gift auto-add stops at config.endsAt even if enabled is still true.
 * A missing or past endsAt stays off. Preview query cannot extend past the end.
 */
(function () {
  'use strict';

  function readConfig() {
    var el = document.getElementById('rnc-sept-promo-config');
    if (!el) return null;
    try {
      var cfg = JSON.parse(el.textContent);
      if (
        cfg &&
        cfg.allowQueryOverride &&
        typeof location !== 'undefined' &&
        /(?:^|[?&])rnc_fall_ritual_test=1(?:&|$)/.test(location.search || '')
      ) {
        cfg.enabled = true;
      }
      return cfg;
    } catch (e) {
      return null;
    }
  }

  var CONFIG = readConfig() || { enabled: false };

  function normalizeLineItemProperties(properties) {
    if (!properties) return {};
    if (typeof properties === 'object' && !Array.isArray(properties)) return properties;
    if (!Array.isArray(properties)) return {};
    var out = {};
    properties.forEach(function (entry) {
      if (entry && entry.key != null) out[entry.key] = entry.value;
    });
    return out;
  }

  function lineItemProperties(item) {
    return normalizeLineItemProperties(item && item.properties);
  }

  function isSeptPromoGiftLine(item) {
    if (!item) return false;
    var p = lineItemProperties(item);
    var tag = p._rnc_gift || p['_rnc_gift'];
    return tag === 'sept-promo' || tag === 'fall-ritual';
  }

  function isOtherManagedGiftLine(item) {
    if (!item || isSeptPromoGiftLine(item)) return false;
    var p = lineItemProperties(item);
    if (p._rnc_gift === 'welcome' || p['_rnc_gift'] === 'welcome') return true;
    var handle = (item.handle || '').toLowerCase();
    if (handle.indexOf('welcome-gift') >= 0) return true;
    var title = item.product_title || '';
    return title.indexOf('Welcome Gift') >= 0 || title.indexOf('(Welcome Gift)') >= 0;
  }

  function cartHasQualifyingSubscription(cart) {
    if (!cart || !cart.items) return false;
    var handles = CONFIG.qualifyingHandles;
    var requireHandles = Array.isArray(handles) && handles.length > 0;
    return cart.items.some(function (item) {
      if (isSeptPromoGiftLine(item) || isOtherManagedGiftLine(item)) return false;
      if (!(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan)) {
        return false;
      }
      if (!requireHandles) return true;
      var handle = String(item.handle || '')
        .toLowerCase()
        .replace(/^\/products\//, '')
        .split('?')[0];
      return handles.some(function (h) {
        return String(h || '').toLowerCase() === handle;
      });
    });
  }

  function cartMerchandiseSubtotalCents(cart) {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (sum, item) {
      if (isSeptPromoGiftLine(item) || isOtherManagedGiftLine(item)) return sum;
      return sum + (item.final_line_price || 0);
    }, 0);
  }

  function isWelcomeKitBundleSubscribeLine(item) {
    if (!item || isSeptPromoGiftLine(item) || isOtherManagedGiftLine(item)) return false;
    if (!item.selling_plan_allocation) return false;
    var api = window.RNC_BUNDLE_GIFTS;
    if (!api || typeof api.isBundleHandle !== 'function') return false;
    var p = lineItemProperties(item);
    var handle = p._rnc_bundle || p['_rnc_bundle'] || item.handle || '';
    return api.isBundleHandle(handle);
  }

  function cartHasWelcomeKitBundleSubscribe(cart) {
    if (!cart || !cart.items) return false;
    return cart.items.some(isWelcomeKitBundleSubscribeLine);
  }

  function isPastPromoEnd() {
    if (!CONFIG.endsAt) return true;
    var end = Date.parse(CONFIG.endsAt);
    if (isNaN(end)) return true;
    return Date.now() >= end;
  }

  function isPromoActive() {
    if (isPastPromoEnd()) return false;
    if (!CONFIG.enabled) return false;
    if (CONFIG.staffOnly && !CONFIG.staffEligible) return false;
    return true;
  }

  function cartQualifiesForSeptPromo(cart) {
    if (!isPromoActive()) return false;
    if (cartHasWelcomeKitBundleSubscribe(cart)) return false;
    if (!cartHasQualifyingSubscription(cart)) return false;
    return cartMerchandiseSubtotalCents(cart) >= (parseInt(CONFIG.minSpendCents, 10) || 0);
  }

  function cartHasSeptPromoGift(cart) {
    if (!cart || !cart.items) return false;
    return cart.items.some(isSeptPromoGiftLine);
  }

  /** Same variant already in cart as a welcome/other managed gift — do not duplicate for sept promo. */
  function septPromoVariantAlreadyGifted(cart) {
    var variantId = parseInt(CONFIG.giftVariantId, 10);
    if (!cart || !cart.items || !variantId) return false;
    return cart.items.some(function (item) {
      if (parseInt(item.variant_id, 10) !== variantId) return false;
      return isSeptPromoGiftLine(item) || isOtherManagedGiftLine(item);
    });
  }

  function runGiftReconciles(cart) {
    var api = window.RNC_BUNDLE_GIFTS;
    var chain = Promise.resolve(cart);
    if (api && typeof api.reconcileWelcomeGifts === 'function') {
      chain = chain.then(function (c) {
        return api.reconcileWelcomeGifts(c || cart);
      });
    }
    return chain.then(reconcileSeptPromo);
  }

  function applyCartUpdates(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates }),
    }).then(function (r) {
      return r.json();
    });
  }

  function postGiftLine(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [
          {
            id: parseInt(variantId, 10),
            quantity: 1,
            properties: {
              _rnc_gift: 'sept-promo',
            },
          },
        ],
      }),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error((data && data.description) || 'Could not add promo gift');
        return data;
      });
    });
  }

  function buildSeptPromoReconcileUpdates(cart) {
    if (!cart || !cart.items || !isPromoActive()) return null;
    var qualifies = cartQualifiesForSeptPromo(cart);
    var updates = {};
    var seenGift = false;

    cart.items.forEach(function (item) {
      if (!isSeptPromoGiftLine(item)) return;
      var targetQty = 0;
      if (qualifies && !seenGift) {
        targetQty = 1;
        seenGift = true;
      }
      if (item.quantity !== targetQty) {
        updates[item.key] = targetQty;
      }
    });

    return Object.keys(updates).length ? updates : null;
  }

  function reconcileSeptPromo(cart) {
    if (!isPromoActive()) {
      var removal = removalUpdatesForEndedPromo(cart);
      if (!removal) return Promise.resolve(cart);
      return applyCartUpdates(removal).then(function (updated) {
        window.__rncLastCart = updated || cart;
        return updated || cart;
      });
    }

    var updates = buildSeptPromoReconcileUpdates(cart);
    var needsAdd =
      cartQualifiesForSeptPromo(cart) &&
      !cartHasSeptPromoGift(cart) &&
      !septPromoVariantAlreadyGifted(cart);
    var variantId = parseInt(CONFIG.giftVariantId, 10);

    var chain = Promise.resolve(cart);

    if (updates) {
      chain = chain.then(function () {
        return applyCartUpdates(updates);
      });
    }

    if (needsAdd && variantId) {
      chain = chain.then(function (current) {
        if (current && cartHasSeptPromoGift(current)) return current;
        return postGiftLine(variantId).then(function () {
          return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
            return r.json();
          });
        });
      });
    }

    return chain.then(function (finalCart) {
      window.__rncLastCart = finalCart || cart;
      return finalCart || cart;
    });
  }

  function countOtherManagedGiftLines(cart) {
    if (!cart || !cart.items) return 0;
    return cart.items.filter(isOtherManagedGiftLine).length;
  }

  function removalUpdatesForEndedPromo(cart) {
    if (!cart || !cart.items) return null;
    var updates = {};
    cart.items.forEach(function (item) {
      if (!isSeptPromoGiftLine(item) || !item.quantity) return;
      updates[item.key] = 0;
    });
    return Object.keys(updates).length ? updates : null;
  }

  function fetchFreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function pickNewerCartSnapshot(prior, reconciled) {
    if (!prior || !prior.items) return reconciled;
    if (!reconciled || !reconciled.items) return prior;

    var priorGifts = countOtherManagedGiftLines(prior);
    var nextGifts = countOtherManagedGiftLines(reconciled);
    if (priorGifts > nextGifts) return prior;
    return reconciled;
  }

  function shouldRepaintDrawerAfterReconcile(cart) {
    var prior = window.__rncLastCart;
    if (!prior || !prior.items) return true;
    if (!cart || !cart.items) return false;

    var priorGifts = countOtherManagedGiftLines(prior);
    var nextGifts = countOtherManagedGiftLines(cart);
    if (priorGifts > nextGifts) return false;
    if (cartHasWelcomeKitBundleSubscribe(prior) && priorGifts > 0 && nextGifts === 0) return false;
    return true;
  }

  function renderCartAfterReconcile(cart) {
    if (!shouldRepaintDrawerAfterReconcile(cart)) {
      var api = window.RNC_BUNDLE_GIFTS;
      if (api && typeof api.syncDrawerFreeShippingBar === 'function') {
        api.syncDrawerFreeShippingBar(window.__rncLastCart || cart);
      }
      return;
    }

    var api = window.RNC_BUNDLE_GIFTS;
    if (api && typeof api.rncRenderCartDrawer === 'function') {
      api.rncRenderCartDrawer(cart, { refreshMode: 'fast' });
      if (typeof api.syncDrawerFreeShippingBar === 'function') {
        api.syncDrawerFreeShippingBar(cart);
      }
      return;
    }
    if (window.theme && typeof window.theme.updateCartDrawer === 'function') {
      window.theme.updateCartDrawer(cart);
    }
  }

  var reconcileTimer;
  var reconcileInFlight = false;
  var reconcilePending = false;

  function runScheduledReconcile() {
    if (reconcileInFlight) {
      reconcilePending = true;
      return;
    }
    reconcileInFlight = true;

    fetchFreshCart()
      .then(runGiftReconciles)
      .then(function (finalCart) {
        var cached = pickNewerCartSnapshot(window.__rncLastCart, finalCart);
        window.__rncLastCart = cached;
        renderCartAfterReconcile(cached);
        return cached;
      })
      .catch(function () {})
      .finally(function () {
        reconcileInFlight = false;
        if (reconcilePending) {
          reconcilePending = false;
          runScheduledReconcile();
        }
      });
  }

  function scheduleReconcile(cart) {
    clearTimeout(reconcileTimer);

    var delayMs = 150;
    if (cart && cartHasWelcomeKitBundleSubscribe(cart) && !cart.items.some(isOtherManagedGiftLine)) {
      delayMs = 500;
    }

    reconcileTimer = setTimeout(runScheduledReconcile, delayMs);
  }

  function patchCartFetch() {
    if (window.__rncSeptPromoFetchPatched || typeof window.fetch !== 'function') return;
    window.__rncSeptPromoFetchPatched = true;
    var origFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isCartMutate =
        url.indexOf('/cart/add.js') >= 0 ||
        url.indexOf('/cart/update.js') >= 0 ||
        url.indexOf('/cart/change.js') >= 0;
      return origFetch(input, init).then(function (resp) {
        if (!isCartMutate) return resp;
        return resp
          .clone()
          .json()
          .then(function (data) {
            if (data && data.items) {
              window.__rncLastCart = pickNewerCartSnapshot(window.__rncLastCart, data);
              scheduleReconcile(data);
            } else {
              scheduleReconcile();
            }
            return resp;
          })
          .catch(function () {
            scheduleReconcile();
            return resp;
          });
      });
    };
  }

  function initSeptPromo() {
    patchCartFetch();
    fetchFreshCart()
      .then(function (cart) {
        window.__rncLastCart = cart;
        return runGiftReconciles(cart);
      })
      .then(function (cart) {
        var cached = pickNewerCartSnapshot(window.__rncLastCart, cart);
        window.__rncLastCart = cached;
        renderCartAfterReconcile(cached);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSeptPromo);
  } else {
    initSeptPromo();
  }

  window.RNC_SEPT_PROMO = {
    config: CONFIG,
    isPromoActive: isPromoActive,
    cartQualifiesForSeptPromo: cartQualifiesForSeptPromo,
    reconcileSeptPromo: reconcileSeptPromo,
    isSeptPromoGiftLine: isSeptPromoGiftLine,
  };
})();
